import { fetchApi, catchFetchApiError, getFetchApiJSONResponse } from 'shared/functions';

export const fetchPeersNames = id =>
  fetchApi(`/esg/api/${id}/peers-names/`)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
